import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'tr-multiple-offers',
  templateUrl: './multiple-offers.component.html',
  styleUrls: ['./multiple-offers.component.scss']
})
export class MultipleOffersComponent {
    @Input() text: string;
  }



// WEBPACK FOOTER //
// ./src/app/authentication/components/multiple-offers/multiple-offers.component.ts